import { render } from "./ChatRoomNew.vue?vue&type=template&id=7805dadd&scoped=true"
import script from "./ChatRoomNew.vue?vue&type=script&lang=js"
export * from "./ChatRoomNew.vue?vue&type=script&lang=js"

import "./ChatRoomNew.vue?vue&type=style&index=0&id=7805dadd&lang=css"
import "./ChatRoomNew.vue?vue&type=style&index=1&id=7805dadd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7805dadd"]])

export default __exports__